import 'classlist.js';
import debounce from 'lodash.debounce';
import InclusiveToggle from '../utilities/InclusiveToggle';
import breakpoint from '../utilities/Breakpoint';

const hamburger = document.getElementById( 'hamburger' );
const hamburgerToggle = new InclusiveToggle( hamburger );
const navBar = document.getElementById( 'navBar' );
const siteHeader = document.getElementById( 'site-header' );
const main = document.getElementById( 'main' );

let fixedTimeout = null;
let scrolled = false;
let scrollY = 0;
let prevScrollY = 0;
let ticking = false;
let scrollDistance = 0;

function navBarCloseState() {
	navBar.classList.remove( 'is-open' );
}

function navBarOpenState() {
	navBar.classList.add( 'is-open' );
}

function initNavBarToggle() {
	hamburgerToggle.init();
	hamburger.addEventListener( 'open', navBarOpenState, false );
	hamburger.addEventListener( 'close', navBarCloseState, false );
}

function getScrollDistance() {
	// Scroll distance is the distance to be scrolled before the header should be fixed.

	if ( document.body.classList.contains( 'is-page-front' ) && breakpoint() === 'mobile' ) {
		scrollDistance = main.offsetTop;
	} else if ( document.body.classList.contains( 'is-page-front' ) ) {
		scrollDistance = siteHeader.offsetTop + siteHeader.offsetHeight;
	} else {
		scrollDistance = siteHeader.offsetHeight;
	}
	return scrollDistance;
}

function setScrolledClass() {
	if ( scrollY > scrollDistance ) {
		// Only set when initially scrolled.
		if ( !scrolled ) {
			document.body.classList.add( 'is-scrolled' );

			// Change positioning after transition finishes.
			fixedTimeout = window.setTimeout( () => {
				siteHeader.classList.add( 'is-fixed' );
				document.body.classList.add( 'nav-is-fixed' );
			}, 500 );

			scrolled = true;
		}

		// Moving up.
		if ( scrollY < prevScrollY ) {
			document.body.classList.add( 'is-scrolling-up' );
		// Moving down.
		} else {
			document.body.classList.remove( 'is-scrolling-up' );
		}
	} else if ( scrollY === 0 || scrollY < scrollDistance - siteHeader.offsetHeight ) {
		window.clearTimeout( fixedTimeout );
		document.body.classList.remove( 'is-scrolled', 'is-scrolling-up' );
		siteHeader.classList.remove( 'is-fixed' );
		document.body.classList.remove( 'nav-is-fixed' );
		scrolled = false;
	}

	ticking = false;
}

function requestTick() {
	if ( !ticking ) {
		window.requestAnimationFrame( setScrolledClass );
	}

	ticking = true;
}

function onScroll() {
	prevScrollY = scrollY;
	scrollY = window.pageYOffset || document.documentElement.scrollTop;
	requestTick();
}

function initEvents() {
	window.addEventListener( 'resize', debounce( ( ) => {
		getScrollDistance();
	}, 250 ) );
}

function init() {
	initNavBarToggle();
	getScrollDistance();
	initEvents();
	window.addEventListener( 'scroll', onScroll );
}

export default { init };
